module.exports = __webpack_public_path__ + "static/media/the-surfer.d7eb4fd9.webp";